import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { TpETLComponentTypeManifest } from '../interfaces';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { addDryRunObjectTable, getETLComponentInputObject } from '../../utils';
import { addETLDryRunError } from '../../etlDryRun';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const observationMetadata = addDryRunObjectTable(dryRun, comp.outputObjectIds['observationTable'], comp);
  const featureMetadata = addDryRunObjectTable(dryRun, comp.outputObjectIds['featureTable'], comp);

  const matrix = getETLComponentInputObject(dryRun, comp, 'source');
  if (matrix.type !== TpETLObjectTypes.MATRIX) {
    addETLDryRunError(dryRun, `Input is not a matrix`, comp.id, 'source');
    return { abort: false };
  }

  observationMetadata.columns = matrix.obsMetadataColumns.map((col) => structuredClone(col));
  featureMetadata.columns = matrix.featureMetadataColumns.map((col) => structuredClone(col));

  return {
    abort: false,
  };
}

export const manifestETLMatrixToTables: TpETLComponentTypeManifest = {
  id: 'MatrixToTables',
  name: 'Obtain matrix metadata',
  description: 'Split up a matrix in the observation metadata and feature metadata.',
  categoryId: 'matrix',
  icon: <FontAwesomeIcon icon={['far', 'split']} />,
  performDryRun,
  inputs: [
    {
      id: 'source',
      name: 'selected matrix',
      type: TpETLObjectTypes.MATRIX,
      description: 'Matrix to split up',
      obsMetadataColumns: [],
      featureMetadataColumns: [],
    },
  ],
  outputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'observationTable',
      name: 'observation metadata table',
      columns: [],
    },
    {
      type: TpETLObjectTypes.TABLE,
      id: 'featureTable',
      name: 'feature metadata table',
      columns: [],
    },
  ],
  params: [],
};
